import { render, staticRenderFns } from "./QuadTemperatureDevicePanel.vue?vue&type=template&id=1645c160&scoped=true&lang=pug&"
import script from "./QuadTemperatureDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./QuadTemperatureDevicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./QuadTemperatureDevicePanel.vue?vue&type=style&index=0&id=1645c160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645c160",
  null
  
)

export default component.exports